<template>
    <div>
      <vue-loading background-color="rgba(0,0,0,0.0)" :active="loadingLicence" color="#4F41A3" :width="30" :height="30"
        :is-full-page="false" />
      <div class="flex flex-col md:flex-row cursor-pointer">
        <div class="bg-white border border-gray-300 rounded hover:shadow-xl p-6 w-full">
          <div class="flex text-zt-primary-600 pb-4 text-lg">
            <zt-icon name="calendar-day" />
            <p class="pl-2">{{ $t('message.dashboard.uploadLicence') }}</p>
          </div>

          <div v-if="licenceMessage !== ''" :class="errorClass"
            class="alert-company border rounded border-0 flex py-6 px-4 mb-6">
            <div class="flex justify-start items-center mr-4">
              <zt-icon :name="errorIcon" :class="errorIcon" class="info-icon mr-2" />
              <p class="text-zt-base font-normal self-center">
                {{ postResponseMessage }}
              </p>
            </div>
          </div>
          <div class="mb-2">
            <div class="mb-4">
              <zt-autocomplete :label="$t('message.dashboard.colaboratorLabel')" :items="entries" v-model="licenceUser"
                @search="val => searchApi(val)" apiSearch :searchCharacter="3" clearable
                :noResultsText="$t('message.HeaderComponent.noMatchSearch')" outlined returnObject
                data-vs-autocomplete="approver" class="pl-2" @change="onCollaboratorChange"></zt-autocomplete>
            </div>
          </div>
          <div class="mb-4">
            <zt-autocomplete :key="'licType-' + resetKey" :label="$t('message.dashboard.licenseTypeLabel')"  :items="licenceType"
              v-model="licenceTypeSelected" outlined clearable returnObject class="pl-2" @change="selectType"></zt-autocomplete>
          </div>
          <div class="mb-4">
            <div v-if="isCollaboratorSelected">
            <vc-date-picker class="mx-auto" :value="dateRange" mode="range" color="indigo" :attributes="holidays"  
              data-vs-datepicker="datesRange" @input="dateSelected($event)" ref="datepicker" />
            <VDatePicker is-range>
              <template #default="{ inputValue, inputEvents }">
                <div class="flex justify-center items-center py-2">
                  <BaseInput :value="inputValue.start" v-on="inputEvents.start" />
                  <IconArrowRight />
                  <BaseInput :value="inputValue.end" v-on="inputEvents.end" />
                </div>
              </template>
            </VDatePicker>
            <div class="flex justify-between p-2">
              <div @click="modalSichernPeopleInfo = true" class=" text-sm"
                v-if="showVacacionesDetails">
                {{
                    $tc(
                      'message.inicioComponent.licensesAvailable',
                      saldo
                    )
                  }}
              </div>
              <div @click="modalSichernPeopleInfo = true" class=" text-sm text-zt-primary-200 underline  cursor-pointer"
                v-if="showVacacionesDetails">
                {{ $t('message.dashboard.salaryAdvance.seeDetail') }}
              </div>
            </div>
          </div>
          <div v-else >
            <zt-autocomplete :label="$t('message.dashboard.salaryAdvance.expectedDate')" disabled 
               outlined clearable returnObject class="pl-2"></zt-autocomplete>
          </div>
            <zt-check-box v-if="allowsSalaryPaymentAdvance" data-vs-check-box="allowsSalaryPaymentAdvance"
              v-model="salaryPaymentAdvance" color="primary" value="1">
              {{ $t('message.licenseComponent.licenseBox.registerAnticipatePayment') }}
            </zt-check-box>

          </div>
          <div class="mb-2 w-full">
            <zt-button class="w-full" :disabled="!isFormValid || isSubmitting" @click="postLicence">{{
              $t('message.dashboard.LoadAbsences') }}</zt-button>
          </div>
          <div class="flex justify-end text-zt-primary-200 p-4 text-md cursor-pointer" @click="
            $router.push({
              name: 'pendingApproval',
              params: { showPendingProp: 2, routerGo: 'dashboard' }
            })
            " data-vs-button="toPendingApproval">
            <p class="pl-2">{{ $t('message.dashboard.seeAbsences') }}</p>
            <zt-icon name="angle-right" />
          </div>
        </div>
      </div>
      <zt-modal
      :active="modalSichernPeopleInfo"
      @close="modalSichernPeopleInfo = false"
      id="sichernPeopleInfo"
      max-width="80rem"
      :fullscreen="isMobile"
    >
      <template slot="modal-header">
        <div class="p-4 font-bold text-zt-lg">
          <span>{{
            $t('message.licenseComponent.licenseBox.sichernPeopleInfo')
          }}</span>
        </div>
      </template>
      <div class="px-4 pb-4">
        <div class="sichern-people-table">
          <div class="table-container">
            <HolidaysBalanceTable
              :saldo="saldo"
              :details="sichernPeopleDetailsData"
            />
          </div>
        </div>
      </div>
    </zt-modal>
    </div>
</template>

<script>
import moment from 'moment'
import Vue from 'vue'
import Licenses from '@/apiClient/Licenses'
import VCalendar from 'v-calendar'
import { mapGetters, mapActions } from 'vuex'
import Manager from '@/apiClient/Manager'
import HolidaysBalanceTable from '@/modules/Licenses/components/request/HolidaysBalanceTable.vue'
import SichernIntegration from '@/apiClient/SichernIntegration'

Vue.use(VCalendar, {
  componentPrefix: 'vc',
  firstDayOfWeek: 2,
  masks: {
    title: 'MMMM YYYY',
    weekdays: 'W',
    input: ['DD/MM/YYYY'],
    data: ['DD/MM/YYYY']
  }
})
export default {
  components: {
    HolidaysBalanceTable
  },
  name: 'AbsenceToColaborator',
  data() {
    return {
      loadingLicence: false,
      licenceUser: {},
      licenceTypeSelected: '',
      licenceDates: '17/08/2023 - 25/08/2023',
      licenceDate: '17/08/2023 - 25/08/2023',
      licenceMessage: '',
      licenses: {},
      isSubmitting: false,
      postResponseMessage: '',
      licenceType: [],
      resetKey: 0,
      range: {},
      entries: [],
      holidays: [],
      allowsSalaryPaymentAdvance: false,
      salaryPaymentAdvance: false,
      licenceMessageMappings: {
        info: { class: 'bg-certs-info', icon: 'info' },
        error: { class: 'bg-certs-error', icon: 'exclamation-circle-solid' },
        warning: { class: 'bg-certs-warning', icon: 'warning-triangle-solid' },
        default: { class: 'no-errors', icon: 'default-message' }
      },
      modalSichernPeopleInfo: false,
      sichernPeopleDetailsData: null,
      detailsBySubtype: '',
      saldo: 0,
      showVacacionesDetails: false,

    }
  },
  created() {
    this.manager = new Manager()
    this.licenses = new Licenses()
    this.vi = new SichernIntegration()
    this.getLicenceHolidays()
    this.$refs.datepicker.$children[0].$el.placeholder = this.$t("message.HeaderComponent.timePeriod")
  },
  computed: {
    ...mapGetters({
      locale: 'getLocaleForDatepicker'
    }),
    isCollaboratorSelected() {
    return this.licenceUser.id && Object.keys(this.licenceUser).length > 0;
  },
    isFormValid() {
      return (
        this.licenceTypeSelected &&
        this.range.hasOwnProperty('start') &&
        this.range.hasOwnProperty('end')
      )
    },
    errorClass() {
      const licenceMessageMapping = this.licenceMessageMappings[
        this.licenceMessage
      ]
      return licenceMessageMapping
        ? licenceMessageMapping.class
        : this.licenceMessageMappings.default.class
    },
    errorIcon() {
      const licenceMessageMapping = this.licenceMessageMappings[
        this.licenceMessage
      ]
      return licenceMessageMapping
        ? licenceMessageMapping.icon
        : this.licenceMessageMappings.default.icon
    },
    dateRange() {
      const dateParts = this.licenceDates.split(' - ')
      if (dateParts.length === 2) {
        const startDate = this.convertToDate(dateParts[0])
        const endDate = this.convertToDate(dateParts[1])
        return [startDate, endDate]
      }
      return []
    }
  },
  watch: {
    licenceTypeSelected() {
      this.checkAllowsSalaryPaymentAdvance()
    }
  },
  methods: {
    ...mapActions(['setLocale']),
    onCollaboratorChange(newVal) {
      this.licenceUser = newVal || {}
      this.range = {}
      this.licenceDates = ''
      this.licenceTypeSelected = null
      this.licenceType = []
      this.salaryPaymentAdvance = false
      this.allowsSalaryPaymentAdvance = false
      this.showVacacionesDetails = false
      this.sichernPeopleDetailsData = null
      this.saldo = 0
      this.holidays = []
      this.postResponseMessage = ''
      this.licenceMessage = ''
      this.resetKey++

      if (newVal && newVal.id) {
        this.getLicenceData(newVal)
      }
    },
    async getLicenceHolidays() {
      if (!this.licenceUser.id) {
      this.holidays = [];
      return;
    }

    try {
      const holidays = (await this.manager.getLicenceHolidays(this.licenceUser.id)).data.data;
      this.holidays = holidays.map(value => {
        const { id, date, policy, company, description } = value;
        const color =
          policy !== null && policy !== 0
            ? 'green'
            : company !== null && company !== 0
              ? 'blue'
              : 'red';

        const currentDate = new Date(date.replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$3-$2-$1'));
        const nextDate = new Date(currentDate);
        nextDate.setDate(currentDate.getDate() + 1);

        return {
          key: id,
          dates: nextDate,
          dot: { color },
          popover: { label: description }
        };
      });
    } catch (error) {
      this.holidays = [];
    }
    },
    async getLicenceData(selectedUser) {
      if (selectedUser.id) {
        this.postResponseMessage = ''
        this.licenceMessage = ''
        this.loadingLicence = true
        this.licenceType = []
        this.licenceTypeSelected = ''
        try {
          const response = await this.manager.getLicenceTypes(selectedUser.id)
          this.licenceType = response.data.data.map(item => ({
            ...item,
            text: item.alias
          }));
          await this.getLicenceHolidays();
        } catch (error) {
          this.postResponseMessage = this.$t("message.HeaderComponent.failedAgain")
          this.licenceMessage = 'error'
        } finally {
          this.loadingLicence = false
        }
      }
    },
    setInitialDateRange() {
      let dateFrom = new Date(
        moment(this.state.request.fechaDesde, 'DD/MM/YYYY').format('YYYY-MM-DD')
      )
      let dateTo = new Date(
        moment(this.state.request.fechaReingreso, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        )
      )
      dateFrom.setDate(dateFrom.getDate() + 1)
      dateTo.setDate(dateTo.getDate() + 1)
      this.range = {
        start: dateFrom,
        end: dateTo
      }
    },
    async checkAllowsSalaryPaymentAdvance() {
      this.salaryPaymentAdvance = false
      this.allowsSalaryPaymentAdvance = false
      const response = await this.manager.allowsSalaryPaymentAdvance(
        this.licenceTypeSelected.id
      )
      this.allowsSalaryPaymentAdvance =
        response.data.data.allowsSalaryPaymentAdvance
    },
    dateSelected(range) {
      if (range) {
        this.postResponseMessage = ''
        this.licenceMessage = ''
        this.range = {
          start: moment(range.start).format('DD/MM/YYYY'),
          end: moment(range.end).format('DD/MM/YYYY')
        }
        if (
          range.start &&
          range.end &&
          range.start.toDateString() === range.end.toDateString()
        ) {
          this.postResponseMessage = this.$t("message.HeaderComponent.dates")
          this.licenceMessage = 'error'
          this.range = {}
        }
      }
    },
    async postLicence() {
      if (this.isSubmitting) {
        return
      }
      this.isSubmitting = true
      this.postResponseMessage = ''
      try {
        const dateFrom = moment(this.range.start, 'DD/MM/YYYY').format(
          'YYYY-MM-DD'
        )
        const dateTo = moment(this.range.end, 'DD/MM/YYYY').format('YYYY-MM-DD')
        const licenceTypeId = this.licenceTypeSelected.id
        const userId = this.licenceUser.id
        const anticipatePayment = this.salaryPaymentAdvance
        await this.manager.postManagerLicence(
          dateFrom,
          dateTo,
          licenceTypeId,
          userId,
          anticipatePayment
        )
        this.resetState()
        this.licenceMessage = 'info'
        this.postResponseMessage =
          this.$t("message.HeaderComponent.success")
      } catch (error) {
        this.postResponseMessage = this.customErrorMessges(
          error.response.data.codes
        )
        this.licenceMessage = 'error'
      } finally {
        this.isSubmitting = false
      }
    },
    resetState() {
      this.range = {}
      this.$refs.datepicker.$children[0].$el.placeholder = this.$t("message.HeaderComponent.timePeriod")
      this.licenceDates = ''
      this.licenceTypeSelected = ''
      this.salaryPaymentAdvance = false
      this.allowsSalaryPaymentAdvance = false
      this.licenceUser = {}
      this.showVacacionesDetails = false
    },
    customErrorMessges(errorResponse) {

      const processErrorCode = ({ code, message, data }) => {
        const errorValue = data ? data.value : '';
        if (code === 'LICENSE_MANAGER_CREATE_ERROR') {
          return message
        } else if (
          code === 'SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST'
        ) {
          return this.$t(`message.errorReference.${code}`)
        } else if (
          code === 'SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST'
        ) {
          if (this.$t(`message.errorReference.${code}_${message}`)) {
            return this.$t(`message.errorReference.${code}_${message}`)
          }
          return this.$t(`message.errorReference.${code}`)
        } else if (/^SICHERN_PEOPLE_[A-Z_]+$/.test(code)) {
          const keyWithMessage = `message.errorReference.${code}_${message}`
          const translatedWithMessage = this.$t(keyWithMessage)
          if (translatedWithMessage !== keyWithMessage) {
            return translatedWithMessage
          }
          return this.$t(`message.errorReference.${code}`)
        } else if(message === 'RequestedDaysIsNotMultipleOf'){
          return this.$t(`message.errorReference.${code}_${message}`, {errorValue})
        } else {
          return this.$t(`message.errorReference.${code}`)
        }
      }
      return errorResponse.map(processErrorCode)[0]
    },
    convertToDate(dateString) {
      const [day, month, year] = dateString.split('/')
      return `${year}-${month}-${day}`
    },
    async searchApi(val) {
      if (val.length > 2) {
        this.salaryPaymentAdvance = false
        this.allowsSalaryPaymentAdvance = false
        const index = val.indexOf("(")
        try {
          if (index !== -1) {
            val = val.substring(0, index).trim();
          }
          const res = await this.manager.getTeamUsers(val)
          const entries = res.data.data
          this.entries = entries.map(entry => {
            let fullName = `${entry.name} (${entry.cuil})`
            const text =
              fullName.length > this.descriptionLimit
                ? fullName.slice(0, this.descriptionLimit) + '...'
                : fullName
            return { ...entry, text }
          })
        } catch (error) {
          this.entries = []
        }
      }
    },
    async selectType() {
      this.showVacacionesDetails = false
      this.sichernPeopleDetailsData = null
      this.saldo = 0

      if (this.licenceTypeSelected.alias !== 'Vacaciones') {
        return
      }
      try {      
        const [balanceResponse, saldoResponse] = await Promise.all([
          this.vi.getDetailedBalances({ id: this.licenceUser.id }),
          this.licenses.getBalanceByTypes({ id: this.licenceUser.id, typeId: this.licenceTypeSelected.id })
        ])
        const balanceDetails = balanceResponse.data.results.data
        this.sichernPeopleDetailsData = balanceDetails || []
        this.previewDaysVP =
          balanceDetails.balanceOfPeriods &&
          balanceDetails.balanceOfPeriods.length > 0 &&
          balanceDetails.balanceOfPeriods[0].previewDays
            ? balanceDetails.balanceOfPeriods[0].previewDays
            : 0

        this.saldo = saldoResponse.data.results.data[0].available || 0
        this.showVacacionesDetails = true
      } catch (error) {
        this.sichernPeopleDetailsData = null
        this.saldo = 0
      }
    },
  },
  mounted() {
    const inputElement = document.querySelector('input.vc-border-gray-400');
    if (inputElement) {
      inputElement.classList.remove('vc-border-gray-400');
      inputElement.classList.add('vc-border-gray-500');
    }
  }
}
</script>
